
@if (mode() === 'graphical' || mode() === 'both'){
    <div class="flex mb-6">
        <app-assembly-graphical-configurator [lamellaArea]="lamellaArea()" />
    </div>
}

@if( mode() === 'spreadsheet' || mode() === 'both'){
    <app-assembly-spreadsheet-configurator [lamellaArea]="lamellaArea()"/>
}
